import React from "react";
import { ISLAND } from "../mock";
import { Reveal } from "../hooks/useReveal";

const Island = () => {
  const [main, second, third] = ISLAND.images;
  return (
    <section id="island" className="bg-[#1C2621] py-24 md:py-32 scroll-mt-20 relative overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          {/* Text */}
          <div>
            <Reveal className="flex items-center gap-4 mb-6">
              <span className="h-px w-10 bg-[#D2703F]" />
              <span className="eyebrow text-[#D2703F]">{ISLAND.eyebrow}</span>
            </Reveal>
            <Reveal>
              <h2 className="font-serif-display text-[#F4EFE6] leading-none">
                <span className="block text-6xl md:text-7xl lg:text-8xl font-extrabold">{ISLAND.title}</span>
                <span className="block italic font-medium text-3xl md:text-4xl text-[#D2703F] mt-2">{ISLAND.subtitle}</span>
              </h2>
            </Reveal>
            <Reveal delay={100}>
              <p className="mt-8 text-[#F4EFE6]/70 text-lg leading-relaxed whitespace-pre-line">{ISLAND.body1}</p>
            </Reveal>
            <Reveal delay={260}>
              <blockquote className="mt-10 pl-6 border-l-2 border-[#D2703F]">
                <p className="font-serif-display italic text-2xl md:text-3xl text-[#F4EFE6] leading-snug">
                  “{ISLAND.quote}”
                </p>
              </blockquote>
            </Reveal>
          </div>

          {/* Images */}
          <div className="grid grid-cols-2 gap-4">
            <Reveal className="col-span-2">
              <figure className="group relative overflow-hidden rounded-2xl">
                <img src={main.src} alt={main.caption} className="w-full h-72 md:h-96 object-cover transition-transform duration-700 group-hover:scale-105" />
                <figcaption className="absolute bottom-4 left-4 px-3 py-1.5 rounded-full bg-[#1C2621]/70 backdrop-blur-sm text-[#F4EFE6] text-sm">{main.caption}</figcaption>
              </figure>
            </Reveal>
            <Reveal delay={120}>
              <figure className="group relative overflow-hidden rounded-2xl">
                <img src={second.src} alt={second.caption} className="w-full h-48 md:h-56 object-cover transition-transform duration-700 group-hover:scale-105" />
                <figcaption className="absolute bottom-3 left-3 px-3 py-1 rounded-full bg-[#1C2621]/70 backdrop-blur-sm text-[#F4EFE6] text-xs">{second.caption}</figcaption>
              </figure>
            </Reveal>
            <Reveal delay={200}>
              <figure className="group relative overflow-hidden rounded-2xl">
                <img src={third.src} alt={third.caption} className="w-full h-48 md:h-56 object-cover transition-transform duration-700 group-hover:scale-105" />
                <figcaption className="absolute bottom-3 left-3 px-3 py-1 rounded-full bg-[#1C2621]/70 backdrop-blur-sm text-[#F4EFE6] text-xs">{third.caption}</figcaption>
              </figure>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Island;
